<template>
  <div>
    <svg class="svgIcon" version="1.1" id="a" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 200 201" style="enable-background:new 0 0 200 201; height: 100%" xml:space="preserve">
      <path :fill="colour" d="M96,17V9h8v8H96z M112,1v8h8V1H112z M136,1h-8v8h8V1z M184,153h8v8v8h8v-8v-8v-8h-8h-8h-8v8H184z M16,57H0V1h56v56H16z
         M8,49h40V9H8v32V49z M8,113v8v8v8h8h8v-8h-8v-8h8v-8h8v-8h-8v-8h-8v-8H8H0v8v8h8V113z M24,17h-8v8v8v8h8h8h8v-8v-8v-8h-8H24z
         M32,185h8v-8v-8v-8h-8h-8h-8v8v8v8h8H32z M32,105h8v-8v-8h8h8v-8h-8v-8h-8v-8h-8h-8h-8H8H0v8v8h8h8h8v-8h8v8h-8v8v8h8V105z M32,137
        h8v-8h-8V137z M40,145h16v56H0v-56H40z M48,153H8v40h40v-32V153z M48,105h8v-8h-8V105z M56,121v-8h-8h-8v8v8h8v-8H56z M64,73h8v-8
        h-8h-8h-8v8h8H64z M64,33h8v-8h-8V33z M72,41h-8v8v8h8v-8V41z M88,65v8h8h8h8h8v-8h-8h-8h-8v-8h-8v-8h-8v8h-8v8h8H88z M104,49h-8v8
        h8V49z M104,153h-8v8h8V153z M96,177v8h8h8v-8h-8H96z M112,33v8h8v-8h8v-8h8v-8h-8V9h-8v8v8h-8h-8h-8v-8h-8V9h8V1h-8h-8h-8v8h-8v8h8
        v8h8v8h8v8h8h8v-8H112z M112,41h-8v8h8V41z M104,193v8h8h8v-8h-8H104z M112,49v8h8v-8H112z M120,49h8v-8h-8V49z M120,57v8h8h8v-8v-8
        h-8v8H120z M136,41v-8h-8v8H136z M128,185h-8v8h8h8h8v-8h-8H128z M144,73v-8h-8v8H144z M152,145h-8v8h8V145z M176,41h8v-8v-8v-8h-8
        h-8h-8v8v8v8h8H176z M176,65h-8v8h8V65z M168,105h8v16h-8v16h8v8h-8v8h8v8h-8v8h8v-8h8v24h-8v8h16v-16h8v24h-48v-16h16v-8h-8v-8h-8
        v8h-8v-8h-8v8h-8v-8h-8v8h-8v-8h-8v-8h8v-16h8v16h8v-24h-24v8H88v-8h-8v16h8v8h8v16H72v8h16v16h-8v-8h-8v8h-8v-40h8v8h8v-8h-8v-8h-8
        v-16H48v-8h8v-8h16v8h16v-8h8v8h24v-8h24v8h8v-8h-8v-8h8v-8h-8v-8h8v-8h-8v-8h8V65h8v16h16v8h-16v8h8V105h-8v8h8V105z M160,137h-24
        v24h24v-16V137z M184,129h-8v8h8V129z M192,73v-8h-8v8v8v8h8v8h-8h-8v8h8v8v8h8v8h8v-8v-8h-8v-8h8v-8v-8v-8h-8V73z M200,1v56h-56V1
        h48H200z M192,9h-40v40h40V17V9z M84.2,108c-6,0-10.7-4-10.7-10.7c0-6.7,4.4-11,11.1-11c6.4,0,10.6,4.4,10.6,10.6
        C95.2,104.5,89.8,108,84.2,108z M84.4,103.4c2.5,0,4.1-2.5,4.1-6.2c0-3.1-1.2-6.2-4.1-6.2c-3.1,0-4.2,3.2-4.2,6.2
        C80.2,100.7,81.7,103.4,84.4,103.4z M110.5,106.3v-1.4h-0.1c-1.2,1.7-3.2,2.7-5.6,2.7c-5.1,0-8.8-4.2-8.8-10.2c0-6.7,4.4-11,9.5-11
        c2.8,0,4.6,1.2,5.7,2.9h0.1l0.2-2.5h5.6c-0.1,1.3-0.2,3.1-0.2,6.2v11.6c0,4-0.9,7.3-3.2,9.4c-2.3,2-5.4,2.6-8.5,2.6
        c-2.7,0-5.6-0.5-7.5-1.6l1.3-4.9c1.4,0.8,3.7,1.6,6.1,1.6C108.2,111.7,110.5,110,110.5,106.3z M110.4,95.3c0-0.4,0-0.9-0.1-1.2
        c-0.5-1.7-1.7-2.9-3.5-2.9c-2.4,0-4.3,2.1-4.3,5.9c0,3.2,1.6,5.6,4.3,5.6c1.7,0,3-1.1,3.4-2.6c0.2-0.5,0.2-1.1,0.2-1.7V95.3z
         M138.2,97c0,7.1-5.1,10.4-10.3,10.4c-5.7,0-10.1-3.8-10.1-10.1c0-6.3,4.1-10.3,10.4-10.3C134.2,87,138.2,91.1,138.2,97z M132,97.1
        c0-2.9-1.1-5.9-3.9-5.9c-2.9,0-4,3-4,5.9c0,3.4,1.4,5.9,4,5.9C130.4,103,132,100.6,132,97.1z M62.7,77.7v38.9H96v-7.4H71.5V77.7
        H62.7z M117.8,116.6h20.4v-7.4h-20.4V116.6z"/>
      </svg>
  </div>
</template>
<script>
export default {
  props: ['colour']
}
</script>

<style scoped>
.svgIcon {
  width: 48px;
}
</style>
